import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';
import { safeFetch } from '../utils/apiUtils';

const WhatsAppButton = () => {
    const [phoneNumber, setPhoneNumber] = useState('');

    useEffect(() => {
        const fetchPhone = async () => {
            try {
                const { ok, data } = await safeFetch('https://aayushrealproperties.in/nimaibackend/public/api/contact-pages');
                if (ok) {
                    let contactData = null;
                    if (Array.isArray(data)) contactData = data[0];
                    else if (data.data) contactData = Array.isArray(data.data) ? data.data[0] : data.data;

                    if (contactData && contactData.phone_number) {
                        // Clean the phone number to be digits only for the WhatsApp link
                        const cleaned = contactData.phone_number.replace(/\D/g, '');
                        setPhoneNumber(cleaned);
                    }
                }
            } catch (error) {
                console.error('Error fetching phone for WhatsApp:', error);
            }
        };
        fetchPhone();
    }, []);

    // If no phone number is fetched, we could hide it or use a default.
    // Let's use a default if it's empty, or just not render if it's really missing.
    if (!phoneNumber) return null;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent('hi Nimai Solutions i want to Build Digital Product')}`;

    return (
        <a
            href={whatsappUrl}
            className="whatsapp-float"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact us on WhatsApp"
        >
            <FaWhatsapp className="whatsapp-icon" />
        </a>
    );
};

export default WhatsAppButton;
